import React from 'react';
import PropTypes from 'prop-types';
import CheckClosed from '~/Components/Global/Assets/Svgs/CheckClosed';
import CheckOpen from '~/Components/Global/Assets/Svgs/CheckOpen';

const TaskCheckbox = ({ disabled, onClick, completed, paddingTop }) => {
  return completed ? (
    <span
      className="task-item-open"
      onClick={e => disabled || onClick(e)}
      style={{ paddingTop: `${paddingTop}px` }}
    >
      <CheckClosed />
    </span>
  ) : (
    <span
      className="task-item-close"
      onClick={e => disabled || onClick(e)}
      style={{ paddingTop: `${paddingTop}px` }}
    >
      <CheckOpen />
    </span>
  );
};

TaskCheckbox.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  completed: PropTypes.bool,
  paddingTop: PropTypes.number.isRequired,
};

export default TaskCheckbox;
